/**
 * Drug Synonym Map (Frontend)
 *
 * Mirrors the API's src/config/drugSynonyms.js so that client-side
 * filtering in dropdowns can match synonyms (e.g. typing "Semaglutide"
 * surfaces CarniSema products).
 *
 * Maintained by pharmacy ops (Rachael) and Cloud Team.
 * Last updated: 2026-04-16 — BUG-07
 */

const DRUG_SYNONYMS: Record<string, string[]> = {
  // GLP-1 agonists
  semaglutide: ['carnisema', 'carni-sema', 'carni sema'],
  tirzepatide: ['carnitide', 'carni-tide', 'carni tide'],
  carnisema: ['semaglutide'],
  carnitide: ['tirzepatide'],

  // Common brand → generic mappings
  ozempic: ['semaglutide', 'carnisema'],
  wegovy: ['semaglutide', 'carnisema'],
  mounjaro: ['tirzepatide', 'carnitide'],
  zepbound: ['tirzepatide', 'carnitide'],

  // Reverse: compound → generic
  'carni-sema': ['semaglutide', 'carnisema'],
  'carni-tide': ['tirzepatide', 'carnitide'],
}

/**
 * Get search keywords for a product name based on drug synonyms.
 * Returns an array of related terms that should also match when searching.
 */
export function getSearchKeywords(productName: string): string[] {
  const lowerName = productName.toLowerCase()
  const keywords: Set<string> = new Set()

  for (const [term, synonyms] of Object.entries(DRUG_SYNONYMS)) {
    if (lowerName.includes(term)) {
      keywords.add(term)
      synonyms.forEach((s) => keywords.add(s))
    }
  }

  return [...keywords]
}
